module.exports = __webpack_public_path__ + "images/marketing/sean-johnson.jpg";